// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
// interface
import { IBreadcrumbs } from '@app/shared/interfaces/breadcrumbs.interface';
@Component({
  selector: 'pwj-breadcrumbs',
  standalone: true,
  imports: [RouterLink, NgClass, TranslateModule],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent {
  // inputs
  breadcrumbsData = input.required<IBreadcrumbs[]>();
}
